import { Box, Container, Grid, TextField, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { getHealthClientAndPalikaInfoData } from "../../../action/HealthClientInfo";
import { fetchNotificationCount } from "../../../action/searchFilterAction";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import CustomModal from "../../../components/modal/CustomModal";
import RegisterNotificationBell from "../../../components/notification/RegisterNotificationBell";
import { useNotificationAccept } from "../../../components/notification/useNotificationAccept";
import NepaliCalender from "../../../components/nepali-calender";
import RegisterHeader from "../../../components/register-header/RegisterHeader";
import { AppMisc } from "../../../misc/appMisc";
import { CASTE_CODES, ERROR, GENDER_OPTIONS, HTTP_STATUS_CODES, LABINFO, PATIENT_TYPES, REQUIRED_FIELD, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import { AGE_UNITS, LAB_SERVICE, MUL_DARTA_NUMBERS_LIST } from "../../../utils/constants/forms";
import { DateUtils } from "../../../utils/dateUtils";
import LabInfoRegister from "../../users/components/register/lab-info-register/LabInfoRegister";
import styles from "./style";
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect";
import { SessionStorage } from "../../../utils/storage/sessionStorage";
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";

export default function LabInfoForm() {
  const classes = styles();
  const [sewaItemName, setSewaItemName] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [latestRecords, setLatestRecords] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [palikaOptions, setPalikaOptions] = useState([]);
  const [palikaName, setPalikaName] = useState(null);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { pageNumber, rowsPerPage } = useSelector((state) => state.searchFilter);
  const palikaInfo = useSelector(state => state.healthClientInfo);
  const dispatch = useDispatch();

  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      if (data.laboratoryTests?.length) {
        const matchedOptions = data.laboratoryTests.map(test => {
          const matchedOption = sewaItemName.find(opt => opt.value.sewaName === test.sewaName);
          return matchedOption ? matchedOption.value : test;
        });
        setSelectedOptions(matchedOptions.map(item => ({ label: item.sewaName, value: item })));
      }
      return data;
    },
  });

  useEffect(() => {
    setDistrictOptions(AppMisc.getDistrictOptions());
  }, []);

  useEffect(() => {
    if (showModal) {
      register("district", { required: true });
      register("palikaName", { required: true });
      register("ageUnit", { required: true });
      register("gender", { required: true });
      register("labSewa", { required: true });
      register("dartaaMiti", { required: true });
      register("mulDartaaNumber");
      register("patientId");
      register("visitId");
      register("requestId");
    }
  }, [register, showModal]);

  useEffect(() => {
    getLabSewaItems();
  }, []);

  useEffect(() => {
    attachMulDartaaOptions();
  }, []);

  useEffect(() => {
    if (showModal && !modalDefaultValues?.id) {
      getLabNumber();
    }
  }, [showModal, modalDefaultValues?.id]);

  const getLabNumber = () => {
    let url = `${API_URL.sewaDartaaNumber}?register=LABINFO&fiscalYear=${DateUtils.getCurrentFiscalYear()}`;
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setValue("labNumber", jsondata?.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getLatestRecords(fromDate, toDate, searchParams);
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage]);

  const getLabSewaItems = () => {
    return AHMIS.get(API_URL.labsewaItem)
      .then(response => {
        if (response.data.type === SUCCESS) {
          let items = response.data.data?.objectList || response.data.data || [];
          let options = items.map(item => ({ value: item, label: item.sewaName }));
          setSewaItemName(options);
          return options;
        }
        return [];
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        return [];
      });
  };

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    let url = `${API_URL.mulDartaaNumber}?sewaType=${"13"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&otherSewaType=${"13-2"}`;
    AHMIS.get(url).then((response) => {
      let data = response.data?.data || [];
      SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
      data.forEach(item => {
        mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
      });
      setMulDartaaOptions(mulDartaaOptions);
    }).catch((error) => {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    });
  };

  const getLatestRecords = (fromDate, toDate, searchParam) => {
    let url = `${API_URL.labInfo}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${Number(pageNumber)}&rowSize=${rowsPerPage}`;
    if (searchParam) {
      url += "&searchParam=" + searchParam;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTotalSize(jsondata.data.totalSize);
          setLatestRecords(jsondata.data.objectList);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const onHeaderParamChange = (fromDate, toDate, searchParam) => {
    getLatestRecords(fromDate, toDate, searchParam);
  };

  const handleSewaItemChange = (name, value) => {
    setValue(name, value);
  };

  const closeModal = () => {
    reset({
      patientFirstName: "",
      patientLastName: "",
      district: "",
      palikaName: "",
      age: "",
      ageUnit: "",
      gender: "",
      phoneNumber: "",
      wardNumber: "",
      labNumber: "",
      dartaaMiti: null,
      labSewa: [],
      mulDartaaNumber: "",
      patientId: "",
      visitId: "",
      requestId: "",
    });
    setSelectedOptions([]);
    setModalDefaultValues({});
    setPalikaName(null);
    setPalikaOptions([]);
    setShowModal(false);
  };

  const handleDartaaMitiChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  const handleCustomSelectChange = (name, value) => {
    setValue(name, value);
  };

  const handleDistrictChange = (name, value, districtOption) => {
    setValue(name, value);
    setPalikaOptions(districtOption?.palikas || []);
    setValue("palikaName", null);
    setPalikaName(null);
  };

  const handlePalikaNameChange = (name, value) => {
    setPalikaName(value);
    setValue(name, value);
  };

  const populateDistrictAndPalikaName = (district, palika, wardNumber) => {
    if (district && palika) {
      let districtObject = districtOptions.find(
        (obj) => obj.value === district
      );
      if (districtObject) {
        setPalikaOptions(districtObject.palikas || []);
        setValue("district", district);
        setValue("palikaName", palika);
        setPalikaName(palika);
        setModalDefaultValues(prev => ({
          ...prev,
          district: district,
          palikaName: palika,
        }));
      }
    }
    if (wardNumber) {
      setValue("wardNumber", wardNumber);
    }
  };

  useEffect(() => {
    if (!palikaInfo) {
      dispatch(getHealthClientAndPalikaInfoData());
    }
  }, [palikaInfo, dispatch]);

  useEffect(() => {
    if (palikaInfo && showModal && !modalDefaultValues?.id) {
      populateDistrictAndPalikaName(palikaInfo?.district, palikaInfo?.palikaName, palikaInfo?.wardNumber);
    }
  }, [palikaInfo, showModal, modalDefaultValues?.id]);

  const patientInfoSubmit = data => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.labInfo, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeModal();
          setShowModal(false);
          getLatestRecords(fromDate, toDate, searchParams);
          attachMulDartaaOptions();
          if (isFromNotification) {
            dispatch(fetchNotificationCount(LABINFO));
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const handleDeleteRow = (id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
  };

  const deleteLabInfoRow = (data) => {
    AHMIS.delete(`${API_URL.labInfo}/${deleteId}?deleteReason=${data.deletedReason}`)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowDeleteModal(false);
          setDeleteId(null);
          getLatestRecords(fromDate, toDate, searchParams);
        }
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const getRecordDetails = async (id) => {
    try {
      const response = await AHMIS.get(API_URL.labInfo + "/" + id);
      let jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        const options = await getLabSewaItems();
        if (jsondata.data.district) {
          const districtObj = districtOptions.find(obj => obj.value == jsondata.data.district);
          setPalikaOptions(districtObj?.palikas || []);
        }
        Object.keys(jsondata?.data).forEach(key => {
          setValue(key, jsondata.data[key]);
        });
        setModalDefaultValues(jsondata.data);
        setPalikaName(jsondata.data.palikaName);
        if (jsondata.data.labSewa) {
          const matchedValues = jsondata.data.labSewa.map(item => {
            const matchedOption = options.find(opt => opt.value.sewaName === item.sewaName);
            return matchedOption ? matchedOption.value : item;
          });
          setSelectedOptions(matchedValues.map(item => ({ label: item.sewaName, value: item })));
        }
        setShowModal(true);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    } catch (error) {
      AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
    }
  };

  const handleMulDartaaChange = (name, value, options) => {

    let mulDartaaNumbers = SessionStorage.getItem(MUL_DARTA_NUMBERS_LIST);
    if (mulDartaaNumbers) {
      let muldartaaNumberInfo = mulDartaaNumbers.find(obj => obj.mulDartaaNumber == value);
      muldartaaNumberInfo ? updatePatientDetails(muldartaaNumberInfo) : getMuldartaaDetailsFromId(options.id);
    } else {
      getMuldartaaDetailsFromId(options.id)
    }
  };

  const getMuldartaaDetailsFromId = (id) => {
    if (id) {
      AHMIS.get(API_URL.mulDartaaDetailsFromId + "/" + id)
        .then(response => {
          if (response.status === HTTP_STATUS_CODES.OK) {
            updatePatientDetails(response.data);
          }
        })
        .catch(error => {
          AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        });
    }
  }

  const updatePatientDetails = (patientDetails) => {
    if (patientDetails) {
      setValue("patientFirstName", patientDetails.patientFirstName);
      setValue("patientLastName", patientDetails.patientLastName);
      setValue("age", patientDetails.age);
      setValue("palikaName", patientDetails.palikaName);
      setValue("wardNumber", patientDetails.wardNumber);
      setValue("gaunOrTole", patientDetails.gaunOrTole);
      setValue("phoneNumber", patientDetails.phoneNumber);
      setValue("mulDartaaNumber", patientDetails.mulDartaaNumber);
      setValue("patientId", patientDetails.patientId);
      setValue("visitId", patientDetails.visitId);
      setValue("requestId", patientDetails.requestId);

      setModalDefaultValues(prev => ({
        ...prev,
        patientFirstName: patientDetails.patientFirstName,
        patientLastName: patientDetails.patientLastName,
        age: patientDetails.age,
        ageUnit: patientDetails.ageUnit,
        gender: patientDetails.gender,
        district: patientDetails.district,
        palikaName: patientDetails.palikaName,
        wardNumber: patientDetails.wardNumber
      }));
    }
  }

  return (
    <Box className={classes.root}>
      <RegisterHeader
        registerTitle="प्रयोगशाला सेवा रजिष्टर"
        handleModalOpen={() => setShowModal(true)}
        onHeaderParamChange={onHeaderParamChange}
        getRegisterData={getLatestRecords}
        lazyLoading
        showSearchField
        rightElement={<RegisterNotificationBell targetRegister={LABINFO} onAccept={handleNotificationAccept} />}
      />
      <CustomModal
        title="प्रयोगशाला सेवा रजिष्टरमा नयाँ रेकर्ड थप्नुहोस्।"
        onModalSubmit={handleSubmit(patientInfoSubmit)}
        showModal={showModal}
        onModalClose={closeModal}
        fullScreen
      >
        <Box display="flex" justifyContent="space-between">
          <Grid container>
            <Grid item xs={12} className={classes.registerContainer}>
              <Box className={classes.content}>
                <Grid container spacing={2} alignItems="center" className={classes.row}>
                  <Grid item xs={12} sm={6} md={3}>
                    <NepaliCalender
                      label="दर्ता मिति"
                      name="dartaaMiti"
                      defaultDate={modalDefaultValues.dartaaMiti}
                      onChange={handleDartaaMitiChange}
                      showDefaultDate
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CustomReactSelect
                      label="मुल दर्ता नं."
                      options={mulDartaaOptions}
                      defaultValue={modalDefaultValues.mulDartaaNumber}
                      name="mulDartaaNumber"
                      onChange={handleMulDartaaChange}
                      isClearable={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      label="सेवाग्राहीको नाम"
                      size="small"
                      variant="outlined"
                      name="patientFirstName"
                      defaultValue={modalDefaultValues.patientFirstName}
                      {...register("patientFirstName", { required: true })}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                    {errors.patientFirstName && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      label="सेवाग्राहीको थर"
                      size="small"
                      variant="outlined"
                      name="patientLastName"
                      defaultValue={modalDefaultValues.patientLastName}
                      {...register("patientLastName", { required: true })}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                    {errors.patientLastName && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      label="प्रयोगशाला दर्ता नं"
                      size="small"
                      variant="outlined"
                      name="labNumber"
                      defaultValue={modalDefaultValues.labNumber}
                      {...register("labNumber", { required: true })}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                    {errors.labNumber && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Tooltip title="सेवाग्राहीको उमेर खुलाउनुहोस" placement="top" arrow>
                      <TextField
                        label="उमेर"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        size="small"
                        variant="outlined"
                        name="age"
                        defaultValue={modalDefaultValues.age}
                        {...register("age", { required: true, min: 1 })}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Tooltip>
                    {errors.age && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CustomReactSelect
                      label="उमेर वर्ष वा महिना"
                      name="ageUnit"
                      size="small"
                      variant="outlined"
                      options={AGE_UNITS}
                      defaultValue={modalDefaultValues.ageUnit}
                      onChange={handleCustomSelectChange}
                      fullWidth
                    />
                    {errors?.ageUnit && errors.ageUnit?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CustomReactSelect
                      label="लिङ्ग"
                      size="small"
                      name="gender"
                      variant="outlined"
                      options={GENDER_OPTIONS}
                      defaultValue={modalDefaultValues.gender}
                      onChange={handleCustomSelectChange}
                      fullWidth
                    />
                    {errors?.gender && errors.gender?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CustomReactSelect
                      label="जिल्ला"
                      size="small"
                      name="district"
                      variant="outlined"
                      options={districtOptions}
                      defaultValue={modalDefaultValues.district}
                      onChange={handleDistrictChange}
                      fullWidth
                    />
                    {errors.district && errors.district?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <CustomReactSelect
                      label="नगर/गाउँपालिका"
                      size="small"
                      name="palikaName"
                      variant="outlined"
                      options={palikaOptions}
                      defaultValue={palikaName}
                      onChange={handlePalikaNameChange}
                      fullWidth
                    />
                    {errors?.palikaName && errors.palikaName?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      label="सम्पर्क नं"
                      size="small"
                      variant="outlined"
                      name="phoneNumber"
                      defaultValue={modalDefaultValues.phoneNumber}
                      {...register("phoneNumber")}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      label="वडा नं"
                      size="small"
                      variant="outlined"
                      name="wardNumber"
                      defaultValue={modalDefaultValues.wardNumber}
                      {...register("wardNumber", { required: true, min: 1 })}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                    {errors.wardNumber && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomReactSelect
                      label="प्रयोगशाला सेवा"
                      name="labSewa"
                      options={sewaItemName}
                      defaultValue={selectedOptions?.map(item => item.value)}
                      onChange={handleSewaItemChange}
                      isClearable
                      isMulti
                      fullWidth
                    />
                    {errors.labSewa && <span className="error-message">{REQUIRED_FIELD}</span>}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showDeleteModal}
        closeDeleteModel={closeDeleteModal}
        deleteRecord={deleteLabInfoRow}
      />
      <Box mt={2}>
        <LabInfoRegister
          tableData={latestRecords}
          totalSize={totalSize}
          rowsPerPage={rowsPerPage}
          page={pageNumber}
          onDeleteRow={handleDeleteRow}
          onEditRow={getRecordDetails}
        />
      </Box>
    </Box>
  );
}
